import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuaranteeSealComponent } from './guarantee-seal.component';
import { createCustomElement } from '@angular/elements';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [GuaranteeSealComponent],
  imports: [CommonModule, PipesModule],
  exports: [GuaranteeSealComponent],
})
export class GuaranteeSealModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(GuaranteeSealComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-guarantee-seal', customComponent);
  }
}
